import React from 'react';
import FormSection from './FormSection';
import { Input } from '../common';
import VendorLookup from '../common/VendorLookup';

const AuditorsVendors = ({ formData, onChange, errors = {} }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Clear error for the field if it has a value
    const updatedData = { [name]: value };
    const updatedErrors = { ...errors };
    
    if (value) {
      delete updatedErrors[name];
      onChange(updatedData, updatedErrors);
    } else {
      onChange(updatedData);
    }
  };

  const handleVendorSelect = (vendor) => {
    const updatedData = {
      externalVendor: vendor.id,
      vendorDetails: {
        supplierCode: vendor.supplier_code,
        supplierName: vendor.supplier_name,
        contactPerson: vendor.contact_person,
        emailAddress: vendor.email_address,
        contractName: vendor.contract_name,
        contractExpiry: vendor.contract_date_expires
      }
    };

    // Clear error when vendor is selected
    const updatedErrors = { ...errors };
    delete updatedErrors.externalVendor;
    
    onChange(updatedData, updatedErrors);
  };

  return (
    <FormSection title="Auditors & Vendors">
      <div className="space-y-6">
        {/* Internal Auditor Section */}
        <div className="border-b border-gray-200 pb-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Internal Auditor</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input
              label="Lead Auditor Internal"
              name="leadAuditorInternal"
              value={formData.leadAuditorInternal}
              onChange={handleInputChange}
              error={errors.leadAuditorInternal}
              placeholder="Select from internal auditors"
            />
            <Input
              label="Lead Auditor Email"
              name="leadAuditorEmail"
              type="email"
              value={formData.leadAuditorEmail}
              onChange={handleInputChange}
              error={errors.leadAuditorEmail}
            />
          </div>
        </div>

        {/* External Auditor Section */}
        <div className="border-b border-gray-200 pb-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">External Auditor</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input
              label="Lead Auditor Name (External)"
              name="leadAuditorNameExternal"
              value={formData.leadAuditorNameExternal}
              onChange={handleInputChange}
              error={errors.leadAuditorNameExternal}
            />
            <Input
              label="Lead Auditor Email (External)"
              name="leadAuditorEmailExternal"
              type="email"
              value={formData.leadAuditorEmailExternal}
              onChange={handleInputChange}
              error={errors.leadAuditorEmailExternal}
            />
          </div>
        </div>

        {/* External Vendor Section */}
        <div className="border-b border-gray-200 pb-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">External Vendor</h3>
          <div className="space-y-6">
            <VendorLookup
              value={formData.externalVendor}
              onChange={(vendorId) => {
                const updatedData = { externalVendor: vendorId };
                const updatedErrors = { ...errors };
                if (vendorId) {
                  delete updatedErrors.externalVendor;
                  onChange(updatedData, updatedErrors);
                } else {
                  onChange(updatedData);
                }
              }}
              onVendorSelect={handleVendorSelect}
              department={formData.department}
              error={errors.externalVendor}
            />

            {formData.vendorDetails && (
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Vendor Details</h4>
                <div className="grid grid-cols-2 gap-4 text-sm text-gray-600">
                  <div>
                    <span className="font-medium">Supplier Code:</span> {formData.vendorDetails.supplierCode}
                  </div>
                  <div>
                    <span className="font-medium">Supplier Name:</span> {formData.vendorDetails.supplierName}
                  </div>
                  <div>
                    <span className="font-medium">Contact Person:</span> {formData.vendorDetails.contactPerson}
                  </div>
                  <div>
                    <span className="font-medium">Email:</span> {formData.vendorDetails.emailAddress}
                  </div>
                  <div>
                    <span className="font-medium">Contract:</span> {formData.vendorDetails.contractName}
                  </div>
                  <div>
                    <span className="font-medium">Contract Expires:</span>{' '}
                    {formData.vendorDetails.contractExpiry
                      ? new Date(formData.vendorDetails.contractExpiry).toLocaleDateString()
                      : 'N/A'}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Additional Auditors */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-4">Additional Auditors</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[2, 3, 4, 5].map(num => (
              <div key={num} className="space-y-4">
                <Input
                  label={`Auditor ${num}`}
                  name={`auditor${num}`}
                  value={formData[`auditor${num}`]}
                  onChange={handleInputChange}
                  error={errors[`auditor${num}`]}
                />
                <Input
                  label={`Auditor ${num} Email`}
                  name={`auditor${num}Email`}
                  type="email"
                  value={formData[`auditor${num}Email`]}
                  onChange={handleInputChange}
                  error={errors[`auditor${num}Email`]}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </FormSection>
  );
};

export default AuditorsVendors;
